import { useQuery } from '@tanstack/react-query';
import { getTechPerformance } from '../services/AnalyticReportsService';
export default function useTechPerformance(filters) {
    return useQuery(['techPerformance', filters.values.dateRange], () => getTechPerformance(filters), { staleTime: 5 * 60 * 1000, cacheTime: 30 * 60 * 1000 });
}
